
export interface Section {
    name: string;
    showName?: boolean;
    groups: Group[];
    licenses: string[];
    permission?: string;
}

export interface Group {
    name: string;
    icon: string;

    group?: string | RegExp;

    items?: Group[];
    permission?: string;
    url?: any;
}


//
// Operations
//

const operationsGroup: Group[] = [
    {
        name: "OPERATIVA",
        icon: "mdi-home-clock-outline",
        group: /^\/operations\/operations/,
        items: [
            {
                name: "Programación",
                icon: "mdi-clock-outline",
                url: { name: "ProductScheduling" },
                permission: "operations.operations.pricing",
            },
            {
                name: "Cierre de ventas",
                icon: "mdi-pause-octagon-outline",
                url: { name: "ProductRestrictions" },
                permission: "operations.operations.stop-sales",
            },
            {
                name: "Planificación diaria",
                icon: "mdi-clock-outline",
                url: { name: "DayScheduling" },
                permission: "operations.operations.scheduling",
            },
            {
                name: "Órdenes de trabajo",
                icon: "mdi-file-tree",
                url: { name: "GetAllWorkOrders" },
                permission: "operations.operations.work-orders",
                // permission: "superuser",
            },
            {
                name: "Planificación de guías",
                icon: "mdi-bell-sleep-outline",
                url: { name: "GetGuidePreferences" },
                permission: "operations.operations.guide-preferences",
            },
        ],
    },
];

//
// Excursions
//

const excursionsGroup: Group[] = [
    {
        name: "MANTENIMIENTOS",
        icon: "mdi-database-outline",
        group: /^\/excursions\/maintenances/,
        items: [
            {
                name: "Zonas",
                icon: "mdi-map-clock",
                url: { name: "GetAllZones" },
                permission: "excursions.maintenances.zones",
            },
            {
                name: "Puntos de recogida",
                icon: "mdi-map-marker",
                url: { name: "GetAllMeetingPoints" },
                permission: "excursions.maintenances.meeting-points",
            },
            {
                name: "Hoteles",
                icon: "mdi-bed-outline",
                url: { name: "GetAllHotels" },
                permission: "excursions.maintenances.hotels",
            },
            {
                name: "Rutas",
                icon: "mdi-routes-clock",
                url: { name: "GetAllRoutes" },
                permission: "excursions.maintenances.routes",
            },

            {
                name: "Actividades",
                icon: "mdi-ticket",
                url: { name: "GetAllActivities" },
                permission: "excursions.maintenances.activities",
            },
            {
                name: "Productos",
                icon: "mdi-sitemap-outline",
                url: { name: "GetAllProducts" },
                permission: "excursions.maintenances.products",
            },
            {
                name: "Tipos de servicios",
                icon: "mdi-shape-outline",
                url: { name: "GetAllGuideRates" },
                permission: "excursions.maintenances.guide-rates",
            },
            {
                name: "Servicios",
                icon: "mdi-google-circles-communities",
                url: { name: "GetAllServices" },
                permission: "excursions.maintenances.services",
            },

            {
                name: "Clientes potenciales",
                icon: "mdi-face-agent",
                url: { name: "GetAllLeads" },
                permission: "excursions.maintenances.leads",
            },

            {
                name: "Programas de actividades",
                icon: "mdi-calendar-month-outline",
                url: { name: "GetAllActivitySchedules" },
                permission: "excursions.maintenances.activity-schedules",
            },
            {
                name: "Tarifas",
                icon: "mdi-tag-multiple-outline",
                url: { name: "GetAllRates" },
                permission: "excursions.maintenances.rates",
            },

            {
                name: "Operadores",
                icon: "mdi-handshake-outline",
                url: { name: "GetAllOperators" },
                permission: "excursions.maintenances.operators",
            },
            {
                name: "Transportistas",
                icon: "mdi-bus",
                url: { name: "GetAllCarriers" },
                permission: "excursions.maintenances.carriers",
            },
            {
                name: "Proveedores",
                icon: "mdi-account-tie-woman",
                url: { name: "GetAllProviders" },
                permission: "excursions.maintenances.providers",
            },
            {
                name: "Guías",
                icon: "mdi-account-voice",
                url: { name: "GetAllGuides" },
                permission: "excursions.maintenances.guides",
            },

            {
                name: "Categorias de actividades",
                icon: "mdi-shape-outline",
                url: { name: "GetAllActivityCategories" },
                permission: "excursions.maintenances.activity-categories",
            },
            {
                name: "Notificaciones automáticas",
                icon: "mdi-send-variant-clock-outline",
                url: { name: "GetAllAutomaticNotificationRules" },
                permission: "excursions.maintenances.automatic-notification-rules",
            },
        ],
    },
    {
        name: "RESERVAS EXCURSIONES",
        icon: "mdi-text-box-outline",
        group: /^\/excursions\/bookings/,
        items: [
            {
                name: "Inbox",
                icon: "mdi-tray-full",
                url: { name: "BookingInbox" },
                permission: "excursions.bookings.inbox",
            },
            {
                name: "Nueva reserva",
                icon: "mdi-text-box-plus-outline",
                url: { name: "NewBooking" },
                permission: "excursions.bookings.booking-center",
            },
            {
                name: "Centro de reservas",
                icon: "mdi-warehouse",
                url: { name: "GetAllBookings" },
                permission: "excursions.bookings.booking-center",
            },
            {
                name: "Presupuestos",
                icon: "mdi-invoice-list-outline",
                url: { name: "GetAllBudgets" },
                permission: "excursions.bookings.budgets",
            },
            // {
            //     name: "Grupos",
            //     icon: "mdi-account-group-outline",
            //     url: { name: "GetAllGroupBookings" },
            //     permission: "excursions.bookings.groups",
            // },
            {
                name: "Puntos de recogida",
                icon: "mdi-text-box-plus-outline",
                url: { name: "MeetingPointsInformation" },
                permission: "excursions.bookings.booking-center",
            },
        ],
    },
];

//
// Transfers
//

const transfersGroup: Group[] = [
    {
        name: "MANTENIMIENTOS",
        icon: "mdi-database-outline",
        group: /^\/transfers\/maintenances/,
        items: [
            {
                name: "Zonas de traslado",
                icon: "mdi-map-clock",
                url: { name: "GetAllTransferZones" },
                permission: "transfers.maintenances.zones",
            },
            {
                name: "Extras",
                icon: "mdi-sticker-plus-outline",
                url: { name: "GetAllTransferExtras" },
                permission: "transfers.maintenances.extras",
            },
            {
                name: "Productos",
                icon: "mdi-sitemap-outline",
                url: { name: "GetAllTransferProducts" },
                permission: "transfers.maintenances.products",
            },
            {
                name: "Tarifas",
                icon: "mdi-tag-multiple-outline",
                url: { name: "GetAllTransferRates" },
                permission: "transfers.maintenances.rates",
            },
        ],
    },
    {
        name: "RESERVAS TRASLADOS",
        icon: "mdi-text-box-outline",
        group: /^\/transfers\/bookings/,
        items: [
            {
                name: "Nueva reserva",
                icon: "mdi-text-box-plus-outline",
                url: { name: "NewTransferBooking" },
                permission: "transfers.bookings.booking-center",
            },
            {
                name: "Centro de reservas",
                icon: "mdi-warehouse",
                url: { name: "GetAllTransferBookings" },
                permission: "transfers.bookings.booking-center",
            },
        ],
    },
];


//
// Administration
//

const administrationGroup: Group[] = [
    {
        name: "MANTENIMIENTOS",
        icon: "mdi-database-outline",
        group: /^\/administration\/maintenances/,
        items: [
            {
                name: "Agencias",
                icon: "mdi-store",
                url: { name: "GetAllAgencies" },
                permission: "administration.maintenances.agencies",
            },
            {
                name: "Empresas",
                icon: "mdi-domain",
                url: { name: "GetAllOrganizations" },
                permission: "administration.maintenances.organizations",
            },
            {
                name: "Tipos de impuestos",
                icon: "mdi-percent-box-outline",
                url: { name: "GetAllTaxes" },
                permission: "administration.maintenances.taxes",
            },
            {
                name: "Series",
                icon: "mdi-counter",
                url: { name: "GetAllSeries" },
                permission: "administration.maintenances.series",
            },
            {
                name: "Reglas de liquidación",
                icon: "mdi-debug-step-over",
                url: { name: "GetAllSettlementRules" },
                permission: "administration.maintenances.settlement-rules",
            },

        ],
    },
    // {
    //     name: "AFILIADOS",
    //     icon: "mdi-currency-eur",
    //     group: /^\/administration\/affiliates/,
    //     items: [
    //         {
    //             name: "Generación de registros",
    //             icon: "mdi-receipt-text-clock-outline",
    //             url: { name: "AffiliateSettlement" },
    //             permission: "administration.affiliates.settlements",
    //         },
    //         {
    //             name: "Consulta de registros",
    //             icon: "mdi-receipt-text-clock-outline",
    //             url: { name: "GetAllAffiliateSalesInvoices" },
    //             permission: "administration.affiliates.invoices",
    //         },
    //     ],
    // },
    {
        name: "LIQUIDACIONES",
        icon: "mdi-currency-eur",
        group: /^\/administration\/settlements/,
        items: [
            {
                name: "Liquidaciones de ventas",
                icon: "mdi-receipt-text-clock-outline",
                url: { name: "AgencySettlement" },
                permission: "administration.settlements.sales",
            },
            {
                name: "Liquidaciones de grupos",
                icon: "mdi-receipt-text-clock-outline",
                url: { name: "BudgetSettlement" },
                permission: "administration.settlements.sales",
            },
            {
                name: "Liquidación operadores",
                icon: "mdi-receipt-text-clock-outline",
                url: { name: "OperatorSettlement" },
                permission: "administration.settlements.purchases",
            },
            {
                name: "Liquidación transportistas",
                icon: "mdi-receipt-text-clock-outline",
                url: { name: "CarrierSettlement" },
                permission: "administration.settlements.purchases",
            },
            {
                name: "Liquidación guías",
                icon: "mdi-receipt-text-clock-outline",
                url: { name: "GuideSettlement" },
                permission: "administration.settlements.purchases",
            },
            {
                name: "Liquidación proveedores",
                icon: "mdi-receipt-text-clock-outline",
                url: { name: "ProviderSettlement" },
                permission: "administration.settlements.purchases",
            },
        ],
    },
    {
        name: "FACTURACIÓN",
        icon: "mdi-currency-eur",
        group: /^\/administration\/invoicing/,
        items: [
            {
                name: "Facturas de venta",
                icon: "mdi-receipt-text-outline",
                url: { name: "GetAllSalesInvoices" },
                permission: "administration.invoicing.sales",
            },
            {
                name: "Facturas de compra",
                icon: "mdi-receipt-text-outline",
                url: { name: "GetAllPurchaseInvoices" },
                permission: "administration.invoicing.purchases",
            },
            {
                name: "SII",
                icon: "mdi-bank",
                url: { name: "GetSiiSalesInvoices" },
                // permission: "administration.invoicing.sii",
                permission: "superuser",
            },
        ],
    },
];

//
// Global
//

const globalGroup: Group[] = [
    // {
    //     name: "AYUDA",
    //     icon: "mdi-tooltip-question-outline",
    //     url: { name: "HelpCenter" },
    //     permission: "global.help-center",
    // },
    {
        name: "CONTENIDO",
        icon: "mdi-multimedia",
        // group: "content",
        group: /^\/global\/content/,
        items: [
            {
                name: "Galería de imágenes",
                icon: "mdi-image-multiple-outline",
                url: { name: "GetAllImages" },
                permission: "*",
            },
            {
                name: "Elementos de contenido",
                icon: "mdi-folder-text-outline",
                url: { name: "GetAllContentElements" },
                permission: "global.content",
            },
            {
                name: "Plantillas de mensajes",
                icon: "mdi-message-cog-outline",
                url: { name: "GetAllMessageTemplates" },
                permission: "global.content",
            },
        ],
    },
    {
        name: "CENTRO DE INFORMES",
        icon: "mdi-file-chart-outline",
        url: { name: "ReportCenter" },
        permission: "global.report-center",
    },
    {
        name: "DOCUMENTACIÓN",
        icon: "mdi-printer-outline",
        url: { name: "documentation-report", params: { websiteId: "" } },
        permission: "*",
    },
    {
        name: "RECURSOS HUMANOS",
        icon: "mdi-human-queue",
        group: /^\/global\/hhrr/,
        items: [
            {
                name: "Empleados",
                icon: "mdi-account-hard-hat-outline",
                url: { name: "GetAllEmployees" },
                permission: "global.hhrr.employees",
            },
            {
                name: "Calendario laboral",
                icon: "mdi-calendar-multiselect-outline",
                url: { name: "GetAllWorkCalendars" },
                permission: "global.hhrr.work-calendars",
            },
            {
                name: "Incidencias",
                icon: "mdi-clock-digital",
                url: { name: "GetAllTimeRecordIncidents" },
                permission: "global.hhrr.time-records",
            },
            {
                name: "Registros horarios",
                icon: "mdi-clock-digital",
                url: { name: "GetAllTimeRecords" },
                permission: "global.hhrr.time-records",
            },
            {
                name: "Vista mensual",
                icon: "mdi-calendar-month-outline",
                url: { name: "GetTimeRecordMonthlyView" },
                permission: "global.hhrr.monthly-view",
            },
            {
                name: "Vista anual",
                icon: "mdi-calendar-month-outline",
                url: { name: "GetTimeRecordYearlyView" },
                permission: "global.hhrr.yearly-view",
            },
        ]
    },
    {
        name: "USUARIOS Y PERFILES",
        icon: "mdi-security",
        group: /^\/global\/administration/,
        items: [

            {
                name: "Perfiles",
                icon: "mdi-account",
                url: { name: "GetAllProfiles" },
                permission: "global.administration.profiles",
            },
            {
                name: "Usuarios (CRS)",
                icon: "mdi-account-multiple",
                url: { name: "GetAllUsers", params: { type: "crs" } },
                permission: "global.administration.users",
            },
            {
                name: "Usuarios (Agencias)",
                icon: "mdi-account-multiple",
                url: { name: "GetAllUsers", params: { type: "agency" } },
                permission: "global.administration.users",
            },
            {
                name: "Usuarios (Guías)",
                icon: "mdi-account-multiple",
                url: { name: "GetAllUsers", params: { type: "guide" } },
                permission: "global.administration.users",
            },

            // {
            //     name: "Pagos electrónicos",
            //     icon: "mdi-credit-card-outline",
            //     url: { name: "GetAllPayments" },
            //     permission: "global.administration.e-payments",
            // },

        ],
    },
    {
        name: "CONFIGURACIÓN",
        icon: "mdi-cog",
        group: /^\/global\/configuration/,
        items: [
            {
                name: "Parámetros",
                icon: "mdi-cog",
                url: { name: "EditConfiguration" },
                // permission: "global.configuration.parameters",
                permission: "superuser",
            },
            {
                name: "Notificaciones",
                icon: "mdi-tray-full",
                url: { name: "GetAllNotifications" },
                permission: "global.configuration.notifications",
            },
            {
                name: "Cuentas de correo",
                icon: "mdi-email-outline",
                url: { name: "GetAllMailAccounts" },
                permission: "global.configuration.mail-accounts",
            },
            {
                name: "Cuentas de WhatsApp",
                icon: "mdi-whatsapp",
                url: { name: "GetAllWhatsAppAccounts" },
                permission: "global.configuration.whatsapp-accounts",
            },
            {
                name: "Integraciones",
                icon: "mdi-memory",
                url: { name: "GetAllIntegrations" },
                permission: "global.configuration.integrations",
            },
            {
                name: "Sitios web",
                icon: "mdi-web",
                url: { name: "GetAllWebsites" },
                // permission: "global.configuration.websites",ç
                permission: "superuser",
            },
            {
                name: "Métodos de pago",
                icon: "mdi-account-credit-card-outline",
                url: { name: "GetAllPaymentMethods" },
                permission: "global.configuration.payment-methods",
            },
            {
                name: "Claves de acceso al API",
                icon: "mdi-api",
                url: { name: "GetAllKeys" },
                // permission: "global.configuration.keys",
                permission: "superuser",
            },
            {
                name: "Tareas programadas",
                icon: "mdi-calendar-check-outline",
                url: { name: "GetAllTasks" },
                // permission: "global.configuration.tasks",
                permission: "superuser",
            },
            {
                name: "Mantenimiento",
                icon: "mdi-wrench-clock",
                url: { name: "Maintenance" },
                // permission: "global.configuration.maintenance",
                permission: "superuser",
            },
        ],
    },
];

export const sections: Section[] = [
    {
        name: "OPERACIONES",
        showName: false,
        groups: operationsGroup,
        licenses: ["0", "1", "2", "3", "4"],
    },
    {
        name: "EXCURSIONES",
        showName: true,
        groups: excursionsGroup,
        licenses: ["0", "1", "2", "3", "4"],
    },
    {
        name: "TRASLADOS",
        showName: true,
        groups: transfersGroup,
        licenses: ["0"],
        //        permission: "superuser",
    },
    {
        name: "ADMINISTRACIÓN",
        showName: true,
        groups: administrationGroup,
        licenses: ["0", "1", "2", "3", "4"],
    },
    {
        name: "SITIOS WEB",
        showName: true,
        groups: [],
        licenses: ["0", "1", "2", "3", "4"]
    },
    {
        name: "GLOBAL",
        showName: true,
        groups: globalGroup,
        licenses: ["0", "1", "2", "3", "4"]
    }
];
